mutation MintOverlayLink($eventId: ID!, $label: String!, $connectionCap: Int) {
  link: StreamToolsMintOverlayLink(eventId: $eventId, label: $label, connectionCap: $connectionCap) {
    linkId
    k
    eventId
    label
    connectionCap
    revoked
    createdAt
    expiresAt
  }
}
